devex = devex || {};
devex.angular = devex.angular || {};
devex.angular.requestTransformers = {
  pluckData: function(data) {
    return data && data.data || [];
  },
  toNumericId: function(data) {
    return _.map(data, function(entry) {
      entry.placeKey = entry.id;
      entry.id = entry.id.split('-')[1];
      return entry;
    });
  },
  mapTextToName: function(data) {
    return _.map(data, function(entry){entry.name = entry.text; return entry});
  },
  mapValueToName: function(data) {
    return _.map(data, function(entry){entry.name = entry.value; return entry});
  },
  mapTextToLongName: function(data) {
    return _.map(data, function(entry){entry.long_name = entry.text; return entry});
  },
  uniqByName: function(data) {
    var uniqData = [],
      addedNames = [];
    data.forEach(function(entry) {
      if (addedNames.indexOf(entry.name) < 0) {
        uniqData.push(entry);
        addedNames.push(entry.name);
      }
    });
    return uniqData;
  },
  log: function(data) {
    return data;
  }
};
